<template>
  <div>
    <el-card class="search-form">
      <search-form
        :model="searchParams"
        :col="3"
        :items="items"
        :loading="loading"
        inline
        label-width="100px"
        @submit="handleSearch"
      ></search-form>
    </el-card>

    <el-card v-loading="loading" class="m-t-md">
      <section class="table-control">
        <el-button type="primary" @click="handleCreate">创建申诉</el-button>
      </section>

      <el-table :data="tableData">
        <el-table-column label="申诉单号" width="125" prop="appealOrder"></el-table-column>
        <el-table-column label="申诉单名称" prop="appealTitle" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column label="申诉类型" width="100" v-slot="{ row }">
          {{ appealTypeMap[row.applicationType] }}
        </el-table-column>
        <el-table-column label="申诉一级场景" width="120" v-slot="{ row }">
          {{ levelOneAppealMap[row.bussType] }}
        </el-table-column>
        <el-table-column label="申诉二级场景" width="120" v-slot="{ row }">
          {{ levelTwoAppealMap[row.complaintType] }}
        </el-table-column>
        <el-table-column label="关联歌曲数" width="100" prop="tracklistCount"></el-table-column>
        <el-table-column label="申诉状态" width="100" v-slot="{ row }">
          {{ appealStatusMap[row.reviewStatus] }}
        </el-table-column>
        <el-table-column label="申诉发起时间" width="170" prop="applicationTime"></el-table-column>
        <el-table-column label="申诉人" width="120" prop="applicationUser"></el-table-column>
        <el-table-column
          label="操作"
          width="140"
          fixed="right"
          align="center"
          v-slot="{ row }"
        >
          <el-button type="text" size="small" @click="handleHistory(row)">流转记录</el-button>
          <el-button v-if="canEdit(row)" type="text" size="small" @click="handleEdit(row)">编辑</el-button>
          <el-button v-if="canCancel(row)" type="text" size="small" @click="handleCancel(row)">取消申诉</el-button>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pagination.current"
        :page-sizes="[20, 50, 100, 1000, 2000]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        class="pagination"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'
import { Complaint } from '@/models/Complaint'
import complaintService from '@/api/complaint'
import { paginationTableMixin } from '@/utils/mixins'
import SearchForm from '@/components/SearchForm'
import {
  APPEAL_STATUS,
  appealTypeMap,
  appealStatusMap,
  levelOneAppealMap,
  levelTwoAppealMap,
  getLevelOneMap,
  getLevelTwoMap
} from '../../../../const'

const isUnf = undefined

function defaultSearchParams() {
  return {
    appealOrder: '',
    appealTitle: '',
    applicationType: isUnf,
    bussType: isUnf,
    complaintType: isUnf,
    reviewStatus: isUnf,
    applicationTime: '',
    insertTime: '',
    applicationUser: '',
    createUser: ''
  }
}

const searchConfigList = [
  {
    label: '申诉单号',
    key: 'appealOrder',
    type: 'text',
    componentProps: {
      placeholder: '请输入申诉单号',
      clearable: true
    }
  },
  {
    label: '申诉状态',
    key: 'reviewStatus',
    type: 'select',
    options: appealStatusMap,
    componentProps: {
      clearable: true
    }
  },
  {
    label: '申诉发起时间',
    key: 'applicationTime',
    type: 'datetime',
    componentProps: {
      placeholder: '请选择申诉发起时间',
      valueFormat: 'yyyy-MM-dd',
      clearable: true
    }
  },
  {
    label: '申诉类型',
    key: 'applicationType',
    type: 'select',
    options: appealTypeMap,
    componentProps: {
      clearable: true
    }
  },
  {
    label: '申诉一级场景',
    key: 'bussType',
    type: 'select',
    options: levelOneAppealMap,
    componentProps: {
      clearable: true
    }
  },
  {
    label: '申诉二级场景',
    key: 'complaintType',
    type: 'select',
    options: levelTwoAppealMap,
    componentProps: {
      clearable: true
    }
  },
]

export default {
  name: 'MyTortList',
  components: {
    SearchForm
  },
  mixins: [paginationTableMixin],
  data() {
    return {
      appealStatusMap,
      appealTypeMap,
      levelOneAppealMap,
      levelTwoAppealMap,
      searchConfigList,

      searchParams: defaultSearchParams(),
    }
  },
  computed: {
    items() {
      const { applicationType, bussType } = this.searchParams
      const configs = cloneDeep(searchConfigList)
      // 申诉一级场景配置处理
      const levelOneConfig = configs.find(v => v.key === 'bussType')
      levelOneConfig.options = getLevelOneMap(applicationType)

      // 申诉二级场景配置处理
      const levelTwoConfig = configs.find(v => v.key === 'complaintType')
      levelTwoConfig.options = getLevelTwoMap(applicationType, bussType)

      return configs
    },
    canEdit: {
      get() {
        return row => {
          // 草稿｜已取消｜驳回，状态下才能编辑
          return [APPEAL_STATUS.DRAFT.code, APPEAL_STATUS.CANCELEED.code, APPEAL_STATUS.REJECT.code].includes(row.reviewStatus)
        }
      }
    },
    canCancel: {
      get() {
        return row => {
          // 待受理，状态下才能取消
          return [APPEAL_STATUS.UNREVIEWED.code].includes(row.reviewStatus)
        }
      }
    },
  },
  watch: {
    'searchParams.applicationType'() {
      this.searchParams.bussType = isUnf
      this.searchParams.complaintType = isUnf
    },
    'searchParams.bussType'() {
      this.searchParams.complaintType = isUnf
    }
  },
  created() {
    this.handleSearch()
  },
  methods: {
    getParams() {
      const { searchParams } = this
      return searchParams
    },
    async fetchData() {
      this.loading = true
      const params = this.getParams()
      try {
        const { total, list } = await complaintService.queryComplaintListForUser({
          ...params,
          page: this.pagination.current - 1,
          num: this.pagination.size
        })
        this.pagination.total = total
        this.tableData = (list || []).map(row => new Complaint(row))
      } catch (error) {
        this.$alert(`查询失败.${error.message}`, '错误', {
          type: 'error',
          error
        })
      }
      this.loading = false
    },
    handleCreate() {
      this.$router.push({ name: 'outsideCpTortEdit' })
    },
    handleHistory(row) {
      this.$router.push({ name: 'outsideCpTortDetail', query: { id: row.id, tab: 'history' } })
    },
    handleEdit(row) {
      this.$router.push({ name: 'outsideCpTortEdit', query: { id: row.id } })
    },
    async handleCancel(row) {
      this.loading = true
      try {
        await complaintService.save({
          id: row.id,
          reviewStatus: APPEAL_STATUS.CANCELEED.code
        })
        row.reviewStatus = APPEAL_STATUS.CANCELEED.code
      } catch (error) {
        this.$alert(`创建失败.${error.message}`, '错误', {
          error,
          type: 'error'
        })
      }
      this.loading = false
    },
  }
}
</script>

<style lang="scss" scoped>
.search-form {
  ::v-deep {
    .el-card__body {
      padding-bottom: 8px;
    }
    .el-form-item--mini.el-form-item {
      margin-bottom: 12px;

      .el-form-item__label {
        color: #002444;
      }
    }
  }
}

.table-control {
  margin-bottom: 14px;
}

/deep/ .el-table__cell .cell .el-button + .el-button {
  margin-left: 0;
}
</style>
